import React from "react";

import { Alert } from "@partials";
import { AlertType } from "@constants";
import { getLocalization } from "@utilities";

import { LocalizationTexts } from "../types";

type AlertSharedProps = {
  localization: LocalizationTexts;
  text: keyof LocalizationTexts;
  alertSource?: string;
};

const AlertShared: React.FC<AlertSharedProps> = ({ localization, text, alertSource = "0" }) => {
  return (
    <div className="mb-8">
      <Alert
        type={AlertType.Error}
        text={getLocalization(localization, text)}
        textAttributes={{ role: "alert", "aria-live": "assertive" }}
        alertSource = {alertSource}
      />
    </div>
  );
};

export default AlertShared;
